module.exports = __webpack_public_path__ + "static/media/ic-social-events.dc1a9830.svg";